import type { TrackingFn } from '@change-corgi/core-react/tracking';

import { openUrlWithHiddenAnchor } from '#src/app/shared/share/utils';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

export function shareWhatsapp(
	// TODO invert text/url for consistency with other shared
	text: string | undefined,
	url: string,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
): void {
	const msg = encodeURIComponent(text ? `${text}\n${url}` : url);
	// A new tab on every device. Facebook's sharer.php takes the current tab for a similar app
	// hand-off, but only on mobile (`!isDesktop`) — on desktop it opens a tab too. This helper gets
	// no device signal, and on desktop `api.whatsapp.com/send` renders WhatsApp Web rather than
	// handing off, so taking the current tab would drop the sharer out of the flow there.
	openUrlWithHiddenAnchor(`https://api.whatsapp.com/send?text=${msg}`, { newTab: true });
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
